import React, { Component } from 'react';
import Grid from '../../common/layout/grid';
import LabelAndText from '../../common/form/labelAndText';

class FichaMicroagulhamento extends Component {
  constructor(props) {
    super(props);
    this.state = props.data;
    this.onChange = this.onChange.bind(this);
  }

  onChange(el){
    this.props.onChange(el);

    const target = el.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render(){
    return(
      <div>
        <Grid cols="12 4">
          <div className="form-group">
            <div className="checkbox">
              <label className="">
                <input type="checkbox" checked={this.state.doencas_frio} name="doencas_frio" onChange={this.onChange} />
                Doenças relacionadas ao frio?
              </label>
            </div>
          </div>
        </Grid>
        <Grid cols="12 4">
          <div className="form-group">
            <div className="checkbox">
              <label className="">
                <input type="checkbox" checked={this.state.hernias} name="hernias" onChange={this.onChange} />
                Hérnias (umbilical ou inguinal)?
              </label>
            </div>
          </div>
        </Grid>
        <Grid cols="12 4">
          <div className="form-group">
            <div className="checkbox">
              <label className="">
                <input type="checkbox" checked={this.state.diastase_abdominal} name="diastase_abdominal" onChange={this.onChange} />
                Diástase Abdominal?
              </label>
            </div>
          </div>
        </Grid>
        <Grid cols="12 4">
          <div className="form-group">
            <div className="checkbox">
              <label className="">
                <input type="checkbox" checked={this.state.lesao_aberta} name="lesao_aberta" onChange={this.onChange} />
                Lesão aberta na pele (furúnculo/dermatites, eczema)?
              </label>
            </div>
          </div>
        </Grid>
        <Grid cols="12 4">
          <div className="form-group">
            <div className="checkbox">
              <label className="">
                <input type="checkbox" checked={this.state.cancer_pele} name="cancer_pele" onChange={this.onChange} />
                Câncer de Pele?
              </label>
            </div>
          </div>
        </Grid>
        <Grid cols="12 4">
          <div className="form-group">
            <div className="checkbox">
              <label className="">
                <input type="checkbox" checked={this.state.insuficiencia_circulatoria} name="insuficiencia_circulatoria" onChange={this.onChange} />
                Insuficiência circulatória periférica (varizes graves)?
              </label>
            </div>
          </div>
        </Grid>
        <Grid cols="12 4">
          <div className="form-group">
            <div className="checkbox">
              <label className="">
                <input type="checkbox" checked={this.state.anticoagulante} name="anticoagulante" onChange={this.onChange} />
                Uso de anticoagulante?
              </label>
            </div>
          </div>
        </Grid>
        <Grid cols="12 4">
          <div className="form-group">
            <div className="checkbox">
              <label className="">
                <input type="checkbox" checked={this.state.cirurgia_recente} name="cirurgia_recente" onChange={this.onChange} />
                Cirurgia recente na área a ser tratada?
              </label>
            </div>
          </div>
        </Grid>

        <LabelAndText name='anamnese_observacoes' handleChange={this.onChange} value={this.state.anamnese_observacoes}
          label='Observações' cols='12' placeholder='Digite aqui' />
      </div>
    );
  }
}

export default FichaMicroagulhamento;
